import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Avatar,
  Rating,
  Divider,
  Pagination,
  PaginationItem,
  MenuItem,
  Select,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Reviews,
} from "@mui/icons-material";

import {
  apiCallReviewVenueStarList

} from "../../../../Core/Apicall";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
export type VenueReview = {
  _id: string;
  venueId: string;
  reviewBy: string;
  rating: number;
  reviews: string;
  reviewPhotos: string[];
  aiGeneratedReviews: string[];
  fullName?: string;
  userAvatar?: string;
};

const VenueReviewsUser: React.FC<{ venueId: string }> = ({ venueId }) => {
  const [reviews, setReviews] = useState<VenueReview[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));
  const fetchReviews = async () => {
    try {
      setLoading(true);
      setError("");
      const payload = {
        venueId,
        offset: page,
        limit: rowsPerPage

      } as any;
      const res = await apiCallReviewVenueStarList(payload);

      if (res?.data) {
        setReviews(res.data);
        setTotalCount(res.totalCount ?? res.data.length ?? 0);
      } else {
        setReviews([]);
        setTotalCount(0);
      }
    } catch (e: any) {
      setError(e?.message || "Failed to load reviews");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [venueId, page, rowsPerPage]);

  const handlePageChange = (value: any) => {
    setPage(value)
  }
  return (
    <Paper sx={{ p: 4, pt: 3, pb: 0 }}>
      <Stack spacing={2} >
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Full Name</TableCell>
                <TableCell>Profile</TableCell>
                <TableCell>Ratings & Questions</TableCell>
              </TableRow>
            </TableHead>
            {loading === false &&
              <TableBody>
                {reviews.map((rev: any) => (
                  <TableRow key={rev._id} hover>
                    <TableCell>{rev.fullName || "-"}</TableCell>
                    <TableCell>
                      {rev.profileImagePath ? (
                        <Avatar
                          src={rev.profileImagePath}
                          alt="Profile"
                          sx={{ width: 50, height: 50 }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      <Stack spacing={1}>
                        {rev.ratings.map((item: any, idx: number) => (
                          <Stack key={idx} spacing={0.5}>
                            <Rating
                              value={Number(item.rating) || 0}
                              precision={0.5}
                              readOnly
                              size="small"
                            />
                            <Typography variant="body2">{item.question}</Typography>
                          </Stack>
                        ))}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>}
          </Table>
          {loading &&
            <CommonShimmer />}
        </TableContainer>
      </Stack>
      <EmptyData data={reviews} />
      <CommonPagination
        page={page}
        rowsPerPage={rowsPerPage}
        totalItems={totalCount}
        totalPages={totalPages}
        onPageChange={(value) => handlePageChange(value)}
        onRowsPerPageChange={(value) => {
          setRowsPerPage(value)
          setPage(1)
        }
        }
      />
    </Paper >
  );
};

export default VenueReviewsUser;
